import { i18n } from '@easydata/core';
import { QueryChangeAction, SortDirection } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { eqCssPrefix } from '../../../utils/utils';
import { browserUtils } from '../../../utils/browser_utils';
var ColumnRendererSB = /** @class */ (function () {
    function ColumnRendererSB(bar, column, slot) {
        this.functionMenu = null;
        this.isMouseOverBlock = false;
        this.keepShowingButtons = false;
        this.bar = bar;
        this.column = column;
        this.element = slot;
    }
    Object.defineProperty(ColumnRendererSB.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-sb';
        },
        enumerable: true,
        configurable: true
    });
    ColumnRendererSB.prototype.render = function () {
        this.baseAttr = this.getAttribute();
        var builder = domel('div');
        builder.data('id', this.column.id);
        if (this.element) {
            //to remove all event listeners
            this.element.parentNode
                .replaceChild(builder.toDOM(), this.element);
        }
        this.element = builder.toDOM();
        builder
            .addClass(this.getClassesToAdd())
            .addClass(browserUtils.getMobileCssClass())
            .addChildElement(this.renderCaptionBlock());
        if (this.isEditable()) {
            builder
                .addChildElement(this.renderSortingButton());
        }
        return this.element;
    };
    ColumnRendererSB.prototype.fireColumnChanged = function () {
        this.column.fireChangedEvent();
    };
    ColumnRendererSB.prototype.refresh = function () {
        this.render();
    };
    ColumnRendererSB.prototype.getAttribute = function () {
        var model = this.bar.getContext().getModel();
        return model.getAttributeById(this.column.expr.value);
    };
    ColumnRendererSB.prototype.isEditable = function () {
        return this.column.enabled && !this.column.isReadOnly();
    };
    ColumnRendererSB.prototype.renderCaptionBlock = function () {
        var _this = this;
        if (!this.column.caption || this.column.caption == '') {
            this.column.caption = this.getDefaultCaption();
        }
        function getArrow(sd) {
            switch (sd) {
                case SortDirection.Ascending:
                    return ' ↑';
                case SortDirection.Descending:
                    return ' ↓';
                default:
                    return '';
            }
        }
        var text = this.column.caption;
        if (!this.isEditable()) {
            text += getArrow(this.column.sorting);
        }
        return domel('div')
            .addClass(this.cssPrefix + "-colelement", this.cssPrefix + "-captionelement")
            .addClass(browserUtils.getMobileCssClass())
            .addChild('div', function (b) { return b
            .title(_this.column.caption)
            .text(text); })
            .toDOM();
    };
    ColumnRendererSB.prototype.renderSortingButton = function () {
        var _this = this;
        var sortButtonCssClass = eqCssPrefix + "-column-sortbutton";
        var sortButtonDirectionCssClass = sortButtonCssClass;
        switch (this.column.sorting) {
            case SortDirection.None:
                sortButtonDirectionCssClass = sortButtonCssClass + "-none";
                break;
            case SortDirection.Ascending:
                sortButtonDirectionCssClass = sortButtonCssClass + "-asc";
                break;
            case SortDirection.Descending:
                sortButtonDirectionCssClass = sortButtonCssClass + "-desc";
                break;
        }
        var builder = domel('div')
            .addClass(this.cssPrefix + "-colelement", this.cssPrefix + "-sortimage-placeholder")
            .addClass(browserUtils.getMobileCssClass())
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-img-sorting", sortButtonDirectionCssClass)
            .title(i18n.getText('ButtonSorting')); })
            .on('touchstart click', function (ev) { return _this.buttonSortingClickHandler(ev, builder.toDOM()); });
        return builder.toDOM();
    };
    ColumnRendererSB.prototype.buttonSortingClickHandler = function (ev, anchor) {
        var _this = this;
        ev.stopPropagation();
        this.keepShowingButtons = true;
        var menu = this.bar.sortMenu;
        menu.showMenu({
            anchor: anchor,
            selectedIds: null,
            itemSelectedCallback: function (data, items) {
                var strToSortDirection = function (str) {
                    if (str == 'None') {
                        return SortDirection.None;
                    }
                    else if (str == "Ascending") {
                        return SortDirection.Ascending;
                    }
                    else if (str == "Descending") {
                        return SortDirection.Descending;
                    }
                };
                if (data.id == 'None' || data.id == "Ascending" || data.id == "Descending") {
                    var query = _this.bar.getContext().getQuery();
                    if (_this.column.isJustSorted() && data.id == 'None') {
                        query.removeColumn(_this.column, _this.bar);
                        query.fireColumnsChangedEvent(QueryChangeAction.Delete, _this.column, true);
                    }
                    else {
                        _this.column.sorting = strToSortDirection(data.id);
                        _this.column.sortIndex = query.getColumnSortIndex(_this.column);
                        _this.fireColumnChanged();
                    }
                }
            },
            menuClosedCallback: function () {
                _this.keepShowingButtons = false;
            }
        });
        return false;
    };
    ColumnRendererSB.prototype.getDefaultCaption = function () {
        return this.getDefaultTitleText(this.baseAttr);
    };
    ColumnRendererSB.prototype.getDefaultTitleText = function (attr) {
        var format = this.bar.options.titleElementFormat || this.bar.options.attrElementFormat;
        var model = this.bar.getContext().getModel();
        return model.getAttributeText(attr, format);
    };
    ColumnRendererSB.prototype.getClassesToAdd = function () {
        return this.cssPrefix + "-row " + this.cssPrefix + "-row-column-entattr";
    };
    ColumnRendererSB.prototype.getUIS = function () {
        return this.bar
            .getContext().getModel()
            .checkAttrProperty(this.column.expr.value, "useInSorting");
    };
    return ColumnRendererSB;
}());
export { ColumnRendererSB };
//# sourceMappingURL=column_renderer_sp.js.map